if (!navigator.cookieEnabled) {
    alert('Please enable cookies');
}

window.api = process.env.VUE_APP_LUDUM_API_URL;

import '@/bootstrap';
import global from '@/mixins/global';
import { i18n, initLang } from '@/lang';
initLang();
import router from './router';
import store from './store/index';
import './registerServiceWorker';
import '@/third-parties/intercom';
// import './third-parties/heap.js';
import Auth from '@/packages/auth/Auth';
import App from './App.vue';
import LoadScript from 'vue-plugin-load-script';
import Meta from 'vue-meta';
import VueClipboard from 'vue-clipboard2';
import VueCookie from 'vue-cookie';
import VueDatetime from 'vue-datetime';
import VueSweetAlert from 'vue-sweetalert';
import { Plugin } from 'vue-fragment';

Vue.use(Auth);
Vue.use(LoadScript);
Vue.use(Meta);
Vue.use(Plugin);
Vue.use(VueClipboard);
Vue.use(VueCookie);
Vue.use(VueDatetime);
Vue.use(VueSweetAlert);

Vue.mixin(global);

Vue.config.productionTip = false;

export default new Vue({
    router,
    i18n,
    store,
    created() {
        this.$store.dispatch('ai/init');
        this.$store.dispatch('ai/loadModel');
    },
    render: h => h(App)
}).$mount('#app');
